import { BaseService } from './base.service'
import { ErrorWrapper } from './util'

// Recomendações de upsell/downsell do funil da compra que gerou a matrícula
// (Story-6066). Contrato:
//   GET {EAD_API}/enrolls/{enrollId}/recommendations
//   200 { items: [...] }  — lista vazia vem como 200 + [], nunca 204
//   404                   — matrícula inexistente ou de outro aluno
// A ordem dos itens já vem pronta (ordem das etapas do funil).
export class RecommendationService extends BaseService {
  static get entity () {
    return 'recommendation'
  }

  static async getByEnroll (enrollId) {
    try {
      const response = await this.request({ auth: true }).get(
        `${process.env.VUE_APP_EAD_API_URL}/enrolls/${enrollId}/recommendations`
      )
      return normalizeRecommendations(response.data)
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}

const isNumber = (v) => typeof v === 'number' && isFinite(v)
const isHttpUrl = (v) => typeof v === 'string' && /^https?:\/\//i.test(v)
const nonEmpty = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null)

// Converte o payload da API no formato usado pelos componentes e descarta
// item que não dá pra renderizar/comprar (sem título, sem preço de venda ou
// sem checkout). Defensivo de propósito: um item ruim some, a lista não quebra.
export function normalizeRecommendations (data) {
  const items = data && Array.isArray(data.items) ? data.items : []
  const seen = new Set()

  return items.reduce((list, item) => {
    if (!item || item.offerId == null || seen.has(item.offerId)) return list

    const title = nonEmpty(item.title)
    const price = item.price || {}
    if (!title || !isNumber(price.sale) || !isHttpUrl(item.checkoutUrl)) return list

    seen.add(item.offerId)
    list.push({
      offerId: item.offerId,
      courseId: item.courseId == null ? null : item.courseId,
      title,
      description: nonEmpty(item.description),
      imageUrl: isHttpUrl(item.imageUrl) ? item.imageUrl : null,
      // null = sem desconto → só o preço de venda. O back já manda null quando
      // original == sale; o `>` cobre também um original menor por engano.
      originalPrice: isNumber(price.original) && price.original > price.sale ? price.original : null,
      salePrice: price.sale,
      checkoutUrl: item.checkoutUrl
    })
    return list
  }, [])
}
